<template>
  <div class="admin-settings">
    <el-container>
      <!-- 顶部导航 -->
      <el-header class="admin-header">
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <i class="el-icon-s-unfold" v-if="!mobileMenuOpen"></i>
          <i class="el-icon-s-fold" v-else></i>
        </div>

        <div class="header-left">
          <h2>永盛制冷维修有限公司-管理系统</h2>
        </div>
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="user-info">
              <i class="el-icon-user-solid"></i>
              <span class="user-name">{{ currentUser?.name || '管理员' }}</span>
              <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 移动端遮罩层 -->
      <div class="mobile-overlay" v-if="mobileMenuOpen" @click="closeMobileMenu"></div>

      <el-container>
        <!-- 侧边栏 -->
        <el-aside width="200px" class="admin-sidebar" :class="{ 'mobile-open': mobileMenuOpen }">
          <el-menu
            :default-active="$route.path"
            router
            background-color="#304156"
            text-color="#bfcbd9"
            active-text-color="#409EFF"
            @select="handleMenuClick"
          >
            <el-menu-item index="/admin/home">
              <i class="el-icon-s-home"></i>
              <span>首页</span>
            </el-menu-item>
            <el-menu-item index="/admin/orders">
              <i class="el-icon-document"></i>
              <span>工单管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/users">
              <i class="el-icon-user"></i>
              <span>用户管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/attendance">
              <i class="el-icon-time"></i>
              <span>考勤管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/salary">
              <i class="el-icon-money"></i>
              <span>薪资管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/statistics">
              <i class="el-icon-s-data"></i>
              <span>统计报表</span>
            </el-menu-item>
            <el-menu-item index="/admin/settings">
              <i class="el-icon-setting"></i>
              <span>系统设置</span>
            </el-menu-item>
          </el-menu>
        </el-aside>

        <!-- 主内容区 -->
        <el-main class="admin-main">
          <div class="page-header">
            <h2>系统设置</h2>
            <p>管理网站基本信息和系统配置</p>
          </div>

          <!-- 设置标签页 -->
          <el-tabs v-model="activeTab" type="card" class="settings-tabs">
            <!-- 基本设置 -->
            <el-tab-pane label="基本设置" name="basic">
              <!-- 网站基本信息 -->
          <el-card class="settings-card" header="网站基本信息">
            <el-form :model="websiteForm" label-width="120px" :disabled="!editingWebsite">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="网站名称">
                    <el-input v-model="websiteForm.site_name" placeholder="请输入网站名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="公司名称">
                    <el-input v-model="websiteForm.company_name" placeholder="请输入公司名称"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="联系电话">
                    <el-input v-model="websiteForm.company_phone" placeholder="请输入联系电话"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客服微信">
                    <el-input v-model="websiteForm.wechat_id" placeholder="请输入客服微信号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="服务时间">
                    <el-input v-model="websiteForm.service_hours" placeholder="请输入服务时间，如：8:00-18:00"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="备案号">
                    <el-input v-model="websiteForm.icp_record" placeholder="请输入ICP备案号"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="公司地址">
                <el-input v-model="websiteForm.company_address" type="textarea" :rows="2" placeholder="请输入公司地址"></el-input>
              </el-form-item>

              <el-form-item label="网站描述">
                <el-input v-model="websiteForm.site_description" type="textarea" :rows="3" placeholder="请输入网站描述"></el-input>
              </el-form-item>

              <el-form-item label="服务范围">
                <el-input v-model="websiteForm.service_area" type="textarea" :rows="2" placeholder="请输入服务范围"></el-input>
              </el-form-item>

              <el-form-item label="版权信息">
                <el-input v-model="websiteForm.copyright_text" type="textarea" :rows="2" placeholder="请输入版权信息"></el-input>
              </el-form-item>
            </el-form>

            <div class="card-actions">
              <el-button v-if="!editingWebsite" type="primary" @click="editingWebsite = true">
                <i class="el-icon-edit"></i>
                编辑信息
              </el-button>
              <template v-else>
                <el-button @click="cancelWebsiteEdit">取消</el-button>
                <el-button type="primary" @click="saveWebsiteInfo" :loading="savingWebsite">
                  <i class="el-icon-check"></i>
                  保存修改
                </el-button>
              </template>
            </div>
          </el-card>

          <!-- 系统配置 -->
          <el-card class="settings-card" header="系统配置">
            <el-form :model="systemForm" label-width="120px" :disabled="!editingSystem">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="系统维护模式">
                    <el-switch
                      v-model="systemForm.maintenance_mode"
                      active-text="开启"
                      inactive-text="关闭">
                    </el-switch>
                    <div class="form-tip">开启后，普通用户将无法访问系统</div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="新用户注册">
                    <el-switch
                      v-model="systemForm.allow_registration"
                      active-text="允许"
                      inactive-text="禁止">
                    </el-switch>
                    <div class="form-tip">是否允许新用户注册</div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="工单自动分配">
                    <el-switch
                      v-model="systemForm.auto_assign_orders"
                      active-text="开启"
                      inactive-text="关闭">
                    </el-switch>
                    <div class="form-tip">自动将工单分配给合适的工人</div>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="邮件通知">
                    <el-switch
                      v-model="systemForm.email_notifications"
                      active-text="开启"
                      inactive-text="关闭">
                    </el-switch>
                    <div class="form-tip">向用户发送邮件通知</div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="系统公告">
                <el-input v-model="systemForm.system_notice" type="textarea" :rows="3" placeholder="请输入系统公告"></el-input>
                <div class="form-tip">将在所有用户界面显示</div>
              </el-form-item>
            </el-form>

            <div class="card-actions">
              <el-button v-if="!editingSystem" type="primary" @click="editingSystem = true">
                <i class="el-icon-edit"></i>
                编辑配置
              </el-button>
              <template v-else>
                <el-button @click="cancelSystemEdit">取消</el-button>
                <el-button type="primary" @click="saveSystemConfig" :loading="savingSystem">
                  <i class="el-icon-check"></i>
                  保存配置
                </el-button>
              </template>
            </div>
          </el-card>

          <!-- 数据库备份 -->
          <el-card class="settings-card" header="数据库备份">
            <div class="backup-section">
              <!-- 立即备份 -->
              <div class="backup-item">
                <div class="backup-info">
                  <h4>立即备份</h4>
                  <p>创建当前数据库的完整备份</p>
                </div>
                <div class="backup-actions">
                  <el-button type="primary" @click="createBackup" :loading="creatingBackup">
                    <i class="el-icon-download"></i>
                    立即备份
                  </el-button>
                </div>
              </div>

              <el-divider></el-divider>

              <!-- 定期备份设置 -->
              <div class="backup-item">
                <div class="backup-info">
                  <h4>定期备份设置</h4>
                  <p>配置自动备份计划</p>
                </div>
                <div class="backup-config">
                  <el-form :model="backupForm" label-width="100px" :disabled="!editingBackup">
                    <el-form-item label="自动备份">
                      <el-switch
                        v-model="backupForm.auto_backup_enabled"
                        active-text="开启"
                        inactive-text="关闭">
                      </el-switch>
                    </el-form-item>
                    
                    <el-form-item label="备份频率" v-if="backupForm.auto_backup_enabled">
                      <el-select v-model="backupForm.backup_frequency" placeholder="请选择备份频率">
                        <el-option label="每天" value="daily"></el-option>
                        <el-option label="每周" value="weekly"></el-option>
                        <el-option label="每月" value="monthly"></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="备份时间" v-if="backupForm.auto_backup_enabled">
                      <el-time-picker
                        v-model="backupForm.backup_time"
                        format="HH:mm"
                        placeholder="选择备份时间">
                      </el-time-picker>
                    </el-form-item>

                    <el-form-item label="保留天数" v-if="backupForm.auto_backup_enabled">
                      <el-input-number
                        v-model="backupForm.retention_days"
                        :min="1"
                        :max="365"
                        label="保留天数">
                      </el-input-number>
                      <div class="form-tip">超过指定天数的备份将被自动删除</div>
                    </el-form-item>
                  </el-form>

                  <div class="card-actions">
                    <el-button v-if="!editingBackup" type="primary" @click="editingBackup = true">
                      <i class="el-icon-edit"></i>
                      编辑设置
                    </el-button>
                    <template v-else>
                      <el-button @click="cancelBackupEdit">取消</el-button>
                      <el-button type="primary" @click="saveBackupConfig" :loading="savingBackup">
                        <i class="el-icon-check"></i>
                        保存设置
                      </el-button>
                    </template>
                  </div>
                </div>
              </div>

              <el-divider></el-divider>

              <!-- 备份历史 -->
              <div class="backup-item">
                <div class="backup-info">
                  <h4>备份历史</h4>
                  <p>查看和管理历史备份文件</p>
                </div>
                <div class="backup-history">
                  <el-button @click="loadBackupHistory" :loading="loadingHistory">
                    <i class="el-icon-refresh"></i>
                    刷新列表
                  </el-button>
                  
                  <el-table :data="backupHistory" style="width: 100%; margin-top: 15px;">
                    <el-table-column prop="filename" label="文件名" min-width="200"></el-table-column>
                    <el-table-column prop="size" label="文件大小" width="100">
                      <template slot-scope="scope">
                        {{ formatFileSize(scope.row.size) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="创建时间" width="180">
                      <template slot-scope="scope">
                        {{ formatDate(scope.row.created_at) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="type" label="类型" width="80">
                      <template slot-scope="scope">
                        <el-tag :type="scope.row.type === 'auto' ? 'success' : 'primary'" size="small">
                          {{ scope.row.type === 'auto' ? '自动' : '手动' }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                      <template slot-scope="scope">
                        <el-button size="mini" @click="downloadBackup(scope.row)">
                          <i class="el-icon-download"></i>
                          下载
                        </el-button>
                        <el-button size="mini" type="danger" @click="deleteBackup(scope.row)">
                          <i class="el-icon-delete"></i>
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-card>
            </el-tab-pane>

            <!-- 公告管理 -->
            <el-tab-pane label="公告管理" name="announcements">
              <el-card class="settings-card" header="系统公告管理">
                <div class="announcement-controls">
                  <el-button type="primary" icon="el-icon-plus" @click="showCreateDialog = true">
                    新建公告
                  </el-button>
                  <el-button type="warning" icon="el-icon-refresh" @click="loadAnnouncements">
                    刷新列表
                  </el-button>
                </div>

                <!-- 公告列表 -->
                <el-table 
                  :data="announcements" 
                  v-loading="loadingAnnouncements"
                  stripe
                  style="width: 100%; margin-top: 20px;">
                  <el-table-column prop="id" label="ID" width="60"></el-table-column>
                  <el-table-column prop="title" label="标题" min-width="200"></el-table-column>
                  <el-table-column prop="type" label="类型" width="80">
                    <template slot-scope="scope">
                      <el-tag :type="getAnnouncementTypeTag(scope.row.type)" size="mini">
                        {{ getAnnouncementTypeName(scope.row.type) }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="priority" label="优先级" width="80">
                    <template slot-scope="scope">
                      <el-tag :type="getPriorityTypeTag(scope.row.priority)" size="mini">
                        {{ getPriorityName(scope.row.priority) }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="显示设置" width="120">
                    <template slot-scope="scope">
                      <div class="display-settings">
                        <el-tooltip content="弹窗显示" placement="top">
                          <el-tag v-if="scope.row.is_popup" type="warning" size="mini">弹窗</el-tag>
                        </el-tooltip>
                        <el-tooltip content="滚动显示" placement="top">
                          <el-tag v-if="scope.row.is_scroll" type="info" size="mini">滚动</el-tag>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="is_active" label="状态" width="80">
                    <template slot-scope="scope">
                      <el-switch 
                        v-model="scope.row.is_active" 
                        :active-value="1"
                        :inactive-value="0"
                        @change="toggleAnnouncementStatus(scope.row)">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="created_at" label="创建时间" width="150">
                    <template slot-scope="scope">
                      {{ formatAnnouncementDate(scope.row.created_at) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button size="mini" @click="editAnnouncement(scope.row)">编辑</el-button>
                      <el-button size="mini" type="danger" @click="deleteAnnouncement(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>

    <!-- 公告创建/编辑对话框 -->
    <el-dialog 
      :title="editingAnnouncement ? '编辑公告' : '新建公告'"
      :visible.sync="showCreateDialog"
      width="800px"
      @close="resetAnnouncementForm">
      <el-form 
        :model="announcementForm" 
        :rules="announcementRules"
        ref="announcementForm"
        label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="公告标题" prop="title">
              <el-input 
                v-model="announcementForm.title" 
                placeholder="请输入公告标题"
                maxlength="100"
                show-word-limit>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公告类型" prop="type">
              <el-select v-model="announcementForm.type" placeholder="请选择公告类型" style="width: 100%">
                <el-option label="信息" value="info"></el-option>
                <el-option label="警告" value="warning"></el-option>
                <el-option label="成功" value="success"></el-option>
                <el-option label="错误" value="error"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优先级" prop="priority">
              <el-select v-model="announcementForm.priority" placeholder="请选择优先级" style="width: 100%">
                <el-option label="低" value="low"></el-option>
                <el-option label="普通" value="normal"></el-option>
                <el-option label="高" value="high"></el-option>
                <el-option label="紧急" value="urgent"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="目标用户" prop="target_users">
              <el-checkbox-group v-model="announcementForm.target_users">
                <el-checkbox label="customer">客户</el-checkbox>
                <el-checkbox label="worker">员工</el-checkbox>
                <el-checkbox label="admin">管理员</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="显示设置">
              <el-checkbox v-model="announcementForm.is_active">启用公告</el-checkbox>
              <el-checkbox v-model="announcementForm.is_popup">登录弹窗显示</el-checkbox>
              <el-checkbox v-model="announcementForm.is_scroll">页面滚动显示</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="announcementForm.start_time"
                type="datetime"
                placeholder="选择开始时间"
                style="width: 100%"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="announcementForm.end_time"
                type="datetime"
                placeholder="选择结束时间"
                style="width: 100%"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="公告内容" prop="content">
              <el-input 
                v-model="announcementForm.content"
                type="textarea"
                :rows="5"
                placeholder="请输入公告内容"
                maxlength="1000"
                show-word-limit>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showCreateDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAnnouncement" :loading="savingAnnouncement">
          {{ editingAnnouncement ? '更新公告' : '创建公告' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminSettings',
  data() {
    return {
      mobileMenuOpen: false,
      activeTab: 'basic', // 默认显示基本设置标签页
      editingWebsite: false,
      editingSystem: false,
      editingBackup: false,
      savingWebsite: false,
      savingSystem: false,
      savingBackup: false,
      creatingBackup: false,
      loadingHistory: false,

      // 公告管理相关
      announcements: [],
      loadingAnnouncements: false,
      showCreateDialog: false,
      editingAnnouncement: null,
      savingAnnouncement: false,
      announcementForm: {
        title: '',
        content: '',
        type: 'info',
        priority: 'normal',
        target_users: ['customer', 'worker', 'admin'],
        is_active: 1,
        is_popup: 0,
        is_scroll: 1,
        start_time: '',
        end_time: ''
      },

      // 网站信息表单
      websiteForm: {
        site_name: '永盛制冷维修有限公司',
        company_name: '永盛制冷维修有限公司',
        company_phone: '',
        wechat_id: 'A13471579359',
        company_address: '',
        site_description: '',
        service_area: '',
        service_hours: '8:00-18:00',
        icp_record: '',
        copyright_text: '© 2025 永盛制冷维修有限公司 版权所有'
      },

      // 系统配置表单
      systemForm: {
        maintenance_mode: false,
        allow_registration: true,
        auto_assign_orders: false,
        email_notifications: true,
        system_notice: ''
      },

      // 备份配置表单
      backupForm: {
        auto_backup_enabled: false,
        backup_frequency: 'daily',
        backup_time: null,
        retention_days: 30
      },

      // 备份历史
      backupHistory: [],

      // 公告表单验证规则
      announcementRules: {
        title: [
          { required: true, message: '请输入公告标题', trigger: 'submit' },
          { min: 2, max: 100, message: '标题长度在 2 到 100 个字符', trigger: 'submit' }
        ],
        content: [
          { required: true, message: '请输入公告内容', trigger: 'submit' },
          { min: 5, max: 1000, message: '内容长度在 5 到 1000 个字符', trigger: 'submit' }
        ],
        type: [
          { required: true, message: '请选择公告类型', trigger: 'change' }
        ],
        priority: [
          { required: true, message: '请选择优先级', trigger: 'change' }
        ],
        target_users: [
          { type: 'array', required: true, message: '请选择目标用户', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted() {
    this.loadSettings()
    this.loadBackupHistory()
    this.loadAnnouncements()
  },
  methods: {
    // 移动端菜单控制
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
    },
    handleMenuClick() {
      this.closeMobileMenu()
    },

    // 用户操作
    async handleCommand(command) {
      if (command === 'logout') {
        try {
          await this.$confirm('确定要退出登录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })

          const result = await this.$store.dispatch('logout')
          if (result.success) {
            this.$message.success('退出登录成功')
            this.$router.push('/login')
          }
        } catch (error) {
          console.log('用户取消退出登录')
        }
      }
    },

    // 加载设置数据
    async loadSettings() {
      try {
        // 获取数据库中的系统设置
        const response = await this.$http.get('/api/settings/', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        // 由于axios拦截器返回response.data，所以response就是后端的数据
        if (response && response.success && response.data) {
          const settings = response.data
          
          // 更新网站信息表单
          if (settings.basic) {
            this.websiteForm.site_name = settings.basic.site_name?.value || this.websiteForm.site_name
            this.websiteForm.company_phone = settings.basic.company_phone?.value || this.websiteForm.company_phone
            this.websiteForm.company_address = settings.basic.company_address?.value || this.websiteForm.company_address
            this.websiteForm.service_hours = settings.basic.service_hours?.value || this.websiteForm.service_hours
            this.websiteForm.icp_record = settings.basic.icp_record?.value || this.websiteForm.icp_record
            this.websiteForm.copyright_text = settings.basic.copyright_text?.value || this.websiteForm.copyright_text
          }
          
          // 更新系统配置表单
          if (settings.system) {
            this.systemForm.maintenance_mode = settings.system.maintenance_mode?.value || this.systemForm.maintenance_mode
            this.systemForm.allow_registration = settings.system.allow_registration?.value || this.systemForm.allow_registration
            this.systemForm.auto_assign_orders = settings.system.auto_assign_orders?.value || this.systemForm.auto_assign_orders
            this.systemForm.email_notifications = settings.system.email_notifications?.value || this.systemForm.email_notifications
            this.systemForm.system_notice = settings.system.system_notice?.value || this.systemForm.system_notice
          }
        }
        
        // 加载备份设置（从原有的JSON文件API）
        try {
          const backupResponse = await this.$http.get('/api/admin/settings')
          if (backupResponse.success && backupResponse.data?.backup) {
            this.backupForm = { ...this.backupForm, ...backupResponse.data.backup }
          }
        } catch (error) {
          console.log('备份设置加载失败，使用默认值')
        }
        
      } catch (error) {
        console.error('加载设置失败:', error)
        this.$message.error('加载设置失败，请刷新重试')
      }
    },

    // 网站信息管理
    cancelWebsiteEdit() {
      this.editingWebsite = false
      this.loadSettings() // 重新加载原始数据
    },

    async saveWebsiteInfo() {
      this.savingWebsite = true
      try {
        // 构建要更新的设置数据
        const settingsData = {
          site_name: this.websiteForm.site_name,
          company_phone: this.websiteForm.company_phone,
          company_address: this.websiteForm.company_address,
          service_hours: this.websiteForm.service_hours,
          icp_record: this.websiteForm.icp_record,
          copyright_text: this.websiteForm.copyright_text
        }

        try {
          const response = await this.$http.put('/api/settings/', settingsData, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          })
          
          // axios拦截器成功时返回response.data，即后端的响应数据
          if (response && response.success) {
            this.$message.success('网站信息保存成功')
            this.editingWebsite = false
            // 通知App.vue重新加载设置
            this.$emit('settings-updated')
          } else {
            this.$message.error('保存失败：' + (response?.message || '未知错误'))
          }
        } catch (axiosError) {
          // 如果数据库更新成功但前端报错，可能是轻微的响应解析问题
          // 尝试重新加载设置来验证是否真的保存成功
          console.warn('API响应异常，尝试验证保存结果:', axiosError)
          
          // 延迟一下再检查，给数据库一点时间
          setTimeout(async () => {
            try {
              await this.loadSettings()
              this.$message.success('网站信息保存成功')
              this.editingWebsite = false
              this.$emit('settings-updated')
            } catch (verifyError) {
              console.error('验证保存结果失败:', verifyError)
              this.$message.error('保存状态不确定，请刷新页面查看')
            }
          }, 500)
        }
      } catch (error) {
        console.error('保存网站信息失败:', error)
        this.$message.error('保存失败：请检查网络连接')
      } finally {
        this.savingWebsite = false
      }
    },

    // 系统配置管理
    cancelSystemEdit() {
      this.editingSystem = false
      this.loadSettings()
    },

    async saveSystemConfig() {
      this.savingSystem = true
      try {
        // 构建要更新的系统设置数据
        const settingsData = {
          maintenance_mode: this.systemForm.maintenance_mode,
          allow_registration: this.systemForm.allow_registration,
          auto_assign_orders: this.systemForm.auto_assign_orders,
          email_notifications: this.systemForm.email_notifications,
          system_notice: this.systemForm.system_notice
        }

        try {
          const response = await this.$http.put('/api/settings/', settingsData, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          })
          
          // axios拦截器成功时返回response.data，即后端的响应数据
          if (response && response.success) {
            this.$message.success('系统配置保存成功')
            this.editingSystem = false
          } else {
            this.$message.error('保存失败：' + (response?.message || '未知错误'))
          }
        } catch (axiosError) {
          // 如果数据库更新成功但前端报错，可能是轻微的响应解析问题
          console.warn('API响应异常，尝试验证保存结果:', axiosError)
          
          // 延迟一下再检查，给数据库一点时间
          setTimeout(async () => {
            try {
              await this.loadSettings()
              this.$message.success('系统配置保存成功')
              this.editingSystem = false
            } catch (verifyError) {
              console.error('验证保存结果失败:', verifyError)
              this.$message.error('保存状态不确定，请刷新页面查看')
            }
          }, 500)
        }
      } catch (error) {
        console.error('保存系统配置失败:', error)
        this.$message.error('保存失败：请检查网络连接')
      } finally {
        this.savingSystem = false
      }
    },

    // 备份配置管理
    cancelBackupEdit() {
      this.editingBackup = false
      this.loadSettings()
    },

    async saveBackupConfig() {
      this.savingBackup = true
      try {
        const response = await this.$http.put('/api/admin/settings/backup', this.backupForm)
        if (response.success) {
          this.$message.success('备份设置保存成功')
          this.editingBackup = false
        } else {
          throw new Error(response.message || '保存失败')
        }
      } catch (error) {
        console.error('保存备份设置失败:', error)
        this.$message.error('保存失败：' + (error.response?.data?.message || error.message))
      } finally {
        this.savingBackup = false
      }
    },

    // 立即备份
    async createBackup() {
      this.creatingBackup = true
      try {
        const response = await this.$http.post('/api/admin/backup/create')
        if (response.success) {
          this.$message.success('数据库备份创建成功')
          this.loadBackupHistory() // 刷新备份历史
        } else {
          throw new Error(response.message || '备份失败')
        }
      } catch (error) {
        console.error('创建备份失败:', error)
        this.$message.error('备份失败：' + (error.response?.data?.message || error.message))
      } finally {
        this.creatingBackup = false
      }
    },

    // 加载备份历史
    async loadBackupHistory() {
      this.loadingHistory = true
      try {
        const response = await this.$http.get('/api/admin/backup/history')
        if (response.success) {
          this.backupHistory = response.data || []
        }
      } catch (error) {
        console.error('加载备份历史失败:', error)
        this.$message.error('加载备份历史失败')
      } finally {
        this.loadingHistory = false
      }
    },

    // 下载备份
    async downloadBackup(backup) {
      try {
        const response = await this.$http.get(`/api/admin/backup/download/${backup.id}`, {
          responseType: 'blob'
        })
        
        // 创建下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', backup.filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
        
        this.$message.success('备份文件下载成功')
      } catch (error) {
        console.error('下载备份失败:', error)
        this.$message.error('下载失败')
      }
    },

    // 删除备份
    async deleteBackup(backup) {
      try {
        await this.$confirm(`确定要删除备份文件"${backup.filename}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const response = await this.$http.delete(`/api/admin/backup/${backup.id}`)
        if (response.success) {
          this.$message.success('备份文件删除成功')
          this.loadBackupHistory()
        } else {
          throw new Error(response.message || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除备份失败:', error)
          this.$message.error('删除失败：' + (error.response?.data?.message || error.message))
        }
      }
    },

    // 工具方法
    formatDate(date) {
      if (!date) return '未知'
      return new Date(date).toLocaleString('zh-CN')
    },

    formatFileSize(bytes) {
      if (!bytes) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },

    // ============================================================================
    // 公告管理方法
    // ============================================================================

    // 加载公告列表
    async loadAnnouncements() {
      this.loadingAnnouncements = true
      try {
        const response = await this.$http.get('/api/announcements/', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        if (response && response.success) {
          this.announcements = response.data.announcements || []
        }
      } catch (error) {
        console.error('加载公告列表失败:', error)
        this.$message.error('加载公告列表失败')
      } finally {
        this.loadingAnnouncements = false
      }
    },

    // 获取公告类型标签
    getAnnouncementTypeTag(type) {
      const tagMap = {
        'info': '',
        'warning': 'warning',
        'success': 'success',
        'error': 'danger'
      }
      return tagMap[type] || ''
    },

    // 获取公告类型名称
    getAnnouncementTypeName(type) {
      const nameMap = {
        'info': '信息',
        'warning': '警告',
        'success': '成功',
        'error': '错误'
      }
      return nameMap[type] || '未知'
    },

    // 获取优先级标签
    getPriorityTypeTag(priority) {
      const tagMap = {
        'low': 'info',
        'normal': '',
        'high': 'warning',
        'urgent': 'danger'
      }
      return tagMap[priority] || ''
    },

    // 获取优先级名称
    getPriorityName(priority) {
      const nameMap = {
        'low': '低',
        'normal': '普通',
        'high': '高',
        'urgent': '紧急'
      }
      return nameMap[priority] || '未知'
    },

    // 格式化公告日期
    formatAnnouncementDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    },

    // 切换公告状态
    async toggleAnnouncementStatus(announcement) {
      try {
        const response = await this.$http.put(`/api/announcements/${announcement.id}`, {
          ...announcement,
          is_active: announcement.is_active
        }, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        if (response && response.success) {
          this.$message.success('状态更新成功')
        }
      } catch (error) {
        console.error('更新状态失败:', error)
        this.$message.error('状态更新失败')
        // 恢复原状态
        announcement.is_active = announcement.is_active === 1 ? 0 : 1
      }
    },

    // 编辑公告
    editAnnouncement(announcement) {
      this.editingAnnouncement = announcement
      // 复制公告数据并转换布尔值
      this.announcementForm = {
        ...announcement,
        is_active: Boolean(announcement.is_active),
        is_popup: Boolean(announcement.is_popup),
        is_scroll: Boolean(announcement.is_scroll)
      }
      this.showCreateDialog = true
    },

    // 删除公告
    async deleteAnnouncement(announcement) {
      try {
        await this.$confirm('确定要删除这条公告吗？', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await this.$http.delete(`/api/announcements/${announcement.id}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        
        if (response && response.success) {
          this.$message.success('删除成功')
          this.loadAnnouncements()
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除公告失败:', error)
          this.$message.error('删除失败')
        }
      }
    },

    // 提交公告（新建或编辑）
    async submitAnnouncement() {
      try {
        // 表单验证
        await this.$refs.announcementForm.validate()
        
        this.savingAnnouncement = true
        
        const formData = { ...this.announcementForm }
        
        // 处理布尔值
        formData.is_active = formData.is_active ? 1 : 0
        formData.is_popup = formData.is_popup ? 1 : 0
        formData.is_scroll = formData.is_scroll ? 1 : 0
        
        let response
        if (this.editingAnnouncement) {
          // 编辑公告
          response = await this.$http.put(`/api/announcements/${this.editingAnnouncement.id}`, formData, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          })
        } else {
          // 新建公告
          response = await this.$http.post('/api/announcements/', formData, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          })
        }
        
        if (response && response.success) {
          this.$message.success(this.editingAnnouncement ? '公告更新成功' : '公告创建成功')
          this.showCreateDialog = false
          this.resetAnnouncementForm()
          this.loadAnnouncements()
        }
        
      } catch (error) {
        if (error.message && error.message.includes('validation')) {
          // 表单验证错误，不显示错误消息
          return
        }
        console.error('提交公告失败:', error)
        this.$message.error(this.editingAnnouncement ? '更新公告失败' : '创建公告失败')
      } finally {
        this.savingAnnouncement = false
      }
    },

    // 重置公告表单
    resetAnnouncementForm() {
      this.editingAnnouncement = null
      this.announcementForm = {
        title: '',
        content: '',
        type: 'info',
        priority: 'normal',
        target_users: ['customer', 'worker', 'admin'],
        is_active: 1,
        is_popup: 0,
        is_scroll: 1,
        start_time: '',
        end_time: ''
      }
      
      // 清除表单验证
      if (this.$refs.announcementForm) {
        this.$refs.announcementForm.clearValidate()
      }
    }
  }
}
</script>

<style scoped>
/* 基础布局样式 */
.admin-settings {
  min-height: 100vh;
  background: #f0f2f5;
}

.admin-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1001;
}

.mobile-menu-btn {
  display: none;
  cursor: pointer;
  font-size: 18px;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.mobile-menu-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.header-left h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.3s;
}

.user-info:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.user-name {
  margin: 0 8px;
  font-weight: 500;
}

.admin-sidebar {
  background: #304156;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.admin-main {
  padding: 20px;
  background: #f0f2f5;
  min-height: calc(100vh - 60px);
}

/* 页面头部 */
.page-header {
  margin-bottom: 20px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7));
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.page-header h2 {
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 24px;
  font-weight: 700;
}

.page-header p {
  margin: 0;
  color: #6c757d;
  font-size: 14px;
}

/* 设置卡片 */
.settings-card {
  margin-bottom: 20px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.settings-card >>> .el-card__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-size: 16px;
  border-bottom: none;
}

.settings-card >>> .el-card__body {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.card-actions {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* 备份相关样式 */
.backup-section {
  padding: 0;
}

.backup-item {
  padding: 20px 0;
}

.backup-item:first-child {
  padding-top: 0;
}

.backup-item:last-child {
  padding-bottom: 0;
}

.backup-info h4 {
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
}

.backup-info p {
  margin: 0;
  color: #6c757d;
  font-size: 14px;
}

.backup-actions {
  margin-top: 15px;
}

.backup-config {
  margin-top: 15px;
}

.backup-history {
  margin-top: 15px;
}

/* 移动端适配 */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
}

@media (max-width: 768px) {
  .mobile-menu-btn {
    display: block;
  }

  .header-left h2 {
    font-size: 16px;
  }

  .user-name {
    display: none;
  }

  .admin-sidebar {
    position: fixed;
    top: 60px;
    left: 0;
    height: calc(100vh - 60px);
    z-index: 1000;
    transform: translateX(-100%);
  }

  .admin-sidebar.mobile-open {
    transform: translateX(0);
  }

  .mobile-overlay {
    display: block;
  }

  .admin-main {
    padding: 15px;
  }

  .page-header {
    padding: 15px;
    margin-bottom: 15px;
  }

  .page-header h2 {
    font-size: 20px;
  }

  .settings-card {
    margin-bottom: 15px;
  }

  .settings-card >>> .el-card__body {
    padding: 15px;
  }

  .backup-item {
    padding: 15px 0;
  }
}

@media (max-width: 480px) {
  .admin-main {
    padding: 10px;
  }

  .page-header {
    padding: 12px;
  }

  .page-header h2 {
    font-size: 18px;
  }

  .settings-card >>> .el-card__body {
    padding: 12px;
  }

  .settings-card >>> .el-form-item {
    margin-bottom: 15px;
  }

  .card-actions {
    text-align: center;
  }

  .card-actions .el-button {
    margin: 5px;
  }
}

/* 公告管理样式 */
.settings-tabs {
  margin-top: 20px;
}

.announcement-controls {
  margin-bottom: 20px;
  text-align: left;
}

.announcement-controls .el-button {
  margin-right: 10px;
}

.display-settings .el-tag {
  margin-right: 5px;
}

.el-table .el-tag {
  margin: 2px;
}

/* 公告标签页内容样式 */
.el-tab-pane {
  padding-top: 0;
}

.settings-tabs >>> .el-tabs__content {
  padding: 0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .announcement-controls {
    text-align: center;
  }
  
  .announcement-controls .el-button {
    margin: 5px;
    width: 48%;
  }
}
</style>